import Link from 'next/link';
import { Stack, HStack, Heading, Image, Divider, IconButton } from '@chakra-ui/react'
import { BsBookmark, BsBookmarkFill } from 'react-icons/bs'
import { useGlobal, useUser } from 'src/context';
import { trackEvent, DEFAULT_AVATAR_SRC } from 'utils';

const GameFirmInfo = props => {
  const { firmsList } = props;
  const { onOpenLogin } = useGlobal();

  const { 
    isLogin,
    isLoadingUser,
    user: { followingFirmsIdList },
    updateList
  } = useUser();

  const handleFirmFollowToggle = (e, { firmId, firmName }) => {
    e.preventDefault();

    trackEvent({
      category: 'Follow--GamePage',
      action: 'Click',
      label: `${firmId}-${firmName}`,
    });

    if (isLogin) {
      updateList('follow', firmId) 
    } else {
      if (!isLoadingUser) onOpenLogin();
    }
  };

  return (
    <div className='mt-4 lg:mt-[58px] mb-6 lg:mb-8'>
      <h4 className='mb-2 pl-2 text-lg leading-none font-bold border-l-4 border-primary'>
        相關工作室
      </h4>
      <Divider />
    
      <Stack spacing={3}>
        {firmsList.map((firmObj, idx) =>{
          const { firmId, firmName, firmLogoUrl } = firmObj;
          const hasFollowed = followingFirmsIdList.includes(firmId);

          return (
            <Link key={`${firmId}-${idx}`} href={`/firm/${firmId}`}>
              <div className='flex justify-between items-center bg-white rounded transition-shadow hover:shadow '>
                <HStack p={2} spacing={3}>
                  <Image
                    boxSize='48px'
                    objectFit='cover'
                    borderRadius='full'
                    boxShadow='md'
                    src={firmLogoUrl}
                    fallbackSrc={DEFAULT_AVATAR_SRC}
                    alt={firmName}
                  />
                  <Heading 
                    as='h5' 
                    size='sm' 
                    noOfLines={1}
                    >
                    {firmName}
                  </Heading>
                </HStack>
                <div className='mr-2'>
                  <IconButton
                    isRound={true}
                    size='sm'
                    colorScheme='primary'
                    variant='ghost'
                    onClick={e => handleFirmFollowToggle(e, { firmId, firmName })}
                    isDisabled={isLoadingUser}
                    icon={hasFollowed ? <BsBookmarkFill /> : <BsBookmark />}
                  />
                </div>
              </div>
            </Link>
          )
        })}
      </Stack>
    </div>
  )
}

export default GameFirmInfo;